// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1DataSetDataSetDataResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1DataSetDataSetDataResponse.attributeTypeMap;
    }
}
PayloadStagingV1DataSetDataSetDataResponse.discriminator = undefined;
PayloadStagingV1DataSetDataSetDataResponse.additionalProperties = false;
PayloadStagingV1DataSetDataSetDataResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1DataSetDataSetDataResponse.js.map